export default __webpack_public_path__ + "static/media/mobiledev.4a0e05ec.jpg";